module.exports = __webpack_public_path__ + "36572dcf77cc1dcdba0624ca56c95e09.png";